let item = {
  /**
   * вызывает только последнее использование метода внутри интервала
   * @param callback
   * @param time
   * @param thread
   * @param n
   */
  callLastInTime: function(callback, time = 1000, thread = "1", n) {
    this.count || (this.count = {});
    if (n && this.count[thread] === n) {
      callback();
      return;
    }
    this.count[thread] || (this.count[thread] = 0);
    if (!n) {
      this.count[thread]++;
      let thisCall = this.count[thread];
      setTimeout(() => {
        item.callLastInTime(callback, time, thread, thisCall);
      }, time);
    }
  },

  /**
   * Отправляет событие в яндекс метрику
   */
  sendMetrika: mark => {
    if (window.ym) {
      window.ym(54376471, "reachGoal", mark);
    }
  },

  /**
   * Функция возвращает окончание для множественного числа слова на основании числа и массива окончаний
   * @param  number Integer Число на основе которого нужно сформировать окончание
   * @param  endingArray  Array Массив слов или окончаний для чисел (1, 4, 5),
   *         например array('яблоко', 'яблока', 'яблок')
   * @return String
   */
  endingWord: function(number, endingArray = ["", "а", "ов"]) {
    let ending, i;
    number = number % 100;
    if (number >= 11 && number <= 19) {
      ending = endingArray[2];
    } else {
      i = number % 10;
      switch (i) {
        case 1:
          ending = endingArray[0];
          break;
        case 2:
        case 3:
        case 4:
          ending = endingArray[1];
          break;
        default:
          ending = endingArray[2];
      }
    }
    return ending;
  }
};

export default item;
